import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.47 5.47a.75.75 0 1 1 1.06 1.06l-12 12a.75.75 0 0 1-1.06-1.06l1.72-1.72H4a.75.75 0 0 1 0-1.5h3.69l4.5-4.5H4a.75.75 0 0 1 0-1.5h9.69zM17.25 9a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75M11.25 15a.75.75 0 0 1 .75-.75h8a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1-.75-.75"
    }, null, -1)
  ])))
}
export default { render: render }